export const SHOPPING_CART_CLEAR = 'SHOPPING_CART_CLEAR';
